export default __webpack_public_path__ + "static/media/ambientguardianlogobaner.b4984322.png";